import { Flex, Spin, Tabs, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { ProductService } from '@services/ProductService'
import { SchoolService } from '@services/SchoolService'

import type { Invitee, Product, School } from '../../../types'

import { DangerZoneTab } from './tabs/DangerZoneTab'
import { InvitedTab } from './tabs/InvitedTab/InvitedTab'
import { SchoolDetailsTab } from './tabs/SchoolDetailsTab'
import { UsersTab } from './tabs/UsersTab/UsersTab'

export const SchoolDetailsPage = () => {
    const [school, setSchool] = useState<School>()
    const [products, setProducts] = useState<Product[]>([])
    const [invitees, setInvitees] = useState<Invitee[]>([])
    const [updateKey, setUpdateKey] = useState<Date>()

    const { id } = useParams()

    const fetchSchool = async () => {
        try {
            const results = await SchoolService.get(id!)
            setSchool(results)
            setUpdateKey(new Date())
        } catch (err) {
            console.error('Error retrieving school information', err)
        }
    }

    const fetchProducts = async () => {
        try {
            const response = await ProductService.list()
            setProducts(response)
        } catch (error) {
            console.error('Error fetching products:', error)
        }
    }

    const fetchInvitees = async () => {
        try {
            const inviteeResponse = await SchoolService.getInvited(id!)
            setInvitees(inviteeResponse)
        } catch (err) {
            console.error('Error retrieving invitees', err)
        }
    }

    useEffect(() => {
        fetchProducts()
        if (id) {
            fetchSchool()
            fetchInvitees()
        }
    }, [id])

    if (!school || !updateKey) {
        return <Spin />
    }

    return (
        <Flex gap="middle" vertical>
            <Typography.Title>{school?.name}</Typography.Title>
            <Tabs style={{ padding: '20px' }}>
                <Tabs.TabPane tab="School Details" key="details">
                    <SchoolDetailsTab school={school} fetch={fetchSchool} products={products} invitees={invitees} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Users" key="users">
                    <UsersTab school={school} fetch={fetchSchool} key={updateKey.toString()} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Invited" key="invited">
                    <InvitedTab school={school} fetch={fetchInvitees} invitees={invitees} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Danger Zone" key="danger">
                    <DangerZoneTab school={school} fetch={fetchSchool} />
                </Tabs.TabPane>
            </Tabs>
        </Flex>
    )
}
